import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
  // バナーカルーセル 最大幅
  const bannerSwiper = document.querySelectorAll('.m__carousel--banner01 .banner-swiper')
  const bannerPage = document.querySelectorAll('.m__carousel--banner01  .swiper-pagination')
  const bannerPrev = document.querySelectorAll('.m__carousel--banner01 .swiper-button-prev')
  const bannerNext = document.querySelectorAll('.m__carousel--banner01 .swiper-button-next')
  if (bannerSwiper.length > 0) {
    for (let i = 0; i < bannerSwiper.length; i++) {
      bannerSwiper[i].className += i
      bannerPage[i].className += i
      bannerPrev[i].className += i
      bannerNext[i].className += i
      const sliderCount = bannerSwiper[i].children[0].children.length
      let loopSetting = true
      if (sliderCount > 3) {
        loopSetting = true
      } else {
        loopSetting = false
      }
      const swiper = new Swiper ('.banner-swiper' + i, {
        'loop': loopSetting,
        'slidesPerView': 3,
        'spaceBetween': 20,
        'autoplay': {
          delay: 5000,
        },
        'pagination': {
          'el': '.m__carousel--banner01 .js-swiper-paging' + i,
          'type': 'bullets',
          'clickable': true
        },
        'navigation': {
          'nextEl': '.m__carousel--banner01 .js-swiper-next' + i,
          'prevEl': '.m__carousel--banner01 .js-swiper-prev' + i
        },
        'watchOverflow': true,
        'breakpoints': {
          '768': {
            'slidesPerView': 1,
            'centeredSlides': true,
            'spaceBetween': 10
          }
        }
      })
    }
  }
})
